import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Jump instantly to the top without animation
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto' // No smooth scroll, immediate jump
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
